import React, { ChangeEvent, useState } from 'react'
import PropTypes from 'prop-types'
import { DeleteIcon, EditIcon } from '@chakra-ui/icons'
import { GridItem, Image, IconButton, Badge, ButtonGroup, Card, CardBody, Center, Flex, FormControl, FormLabel, SimpleGrid, Tooltip, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import AttachmentTypeLookupComponent from '../../lookups/attachmentTypeLookup'

const AssetFileUploadItem = (props) => {

    const textColorBrand = 'brand.500';

    const handleRemoveFileItem = () => {
        props.removeFileItem(props.file.File.name)
    }

    const handleEditImage = () => {
        props.editImageItem(props.file.File, props.index)
    }

    const handleChangeType = (e: any) => {
        props.updateType(e.target.value, props.index)
    }

    const handleChangeName = (e: any) => {
        props.updateName(e.target.value, props.index)
    }

    console.log(props)
    return (


        <Card variant={'outline'} direction={"row"} flex={'row'}
        >
            <CardBody>
                <SimpleGrid columns={4} spacing={5}>



                    <GridItem colSpan={1}>

                        <FormControl isRequired>
                            <FormLabel >Name</FormLabel>
                            <Input type='Name'
                                defaultValue={props.file.File.name}
                                onChange={handleChangeName}
                            />
                        </FormControl>

                    </GridItem>

                    <GridItem colSpan={1}>
                        <AttachmentTypeLookupComponent
                            id="type"
                            name="type"
                            label="Attachment Type"
                            disabled={false}
                            isRequired={true}
                            size={"lg"}
                            fontWeight={"500"}
                            value={props.file.type}
                            onChange={handleChangeType}
                            currentUser={props.currentUser}
                        />


                    </GridItem>

                    <GridItem colSpan={1}>

                        <Image width={{ base: '100%', sm: '75px', xl: '150px' }}
                            src={props.file.Preview}
                            alt={props.file.fileName}
                        />
                    </GridItem>

                    <GridItem colSpan={1}>
                        <Center>
                            <Flex direction={'column'} minWidth='max-content' >
                                <FormLabel>Upload Progress: <Badge color={'Brand'}>{props.file.Progress}%</Badge> </FormLabel>
                                <FormControl>
                                    <ButtonGroup paddingTop={1}>
                                        <Tooltip label="Edit Image" aria-label='Edit Image'>
                                            <IconButton size={"sm"} color={textColorBrand} onClick={() => handleEditImage()} aria-label='Edit' icon={<EditIcon />} /></Tooltip>

                                        <Tooltip label="Remove File" aria-label='Remove File'>
                                            <IconButton size={"sm"} color={'red'} aria-label='Remove File' icon={<DeleteIcon />} onClick={() => handleRemoveFileItem()} />
                                        </Tooltip>
                                    </ButtonGroup>
                                </FormControl>
                                {/* <Progress minWidth='max-content' sx={{
                                    "& > div:first-child": {
                                        transitionProperty: "width",
                                    },
                                }} hasStripe value={props.file.Progress} /> */}
                            </Flex>
                        </Center>
                        {/* </Flex> */}
                    </GridItem>
                </SimpleGrid>

            </CardBody>

        </Card>

    )

}

AssetFileUploadItem.propTypes =
{
    file: PropTypes.any,
    removeFileItem: PropTypes.any,
    editImageItem: PropTypes.any,
    updateType: PropTypes.any,
    updateName: PropTypes.any,
    index: PropTypes.any
}

export default AssetFileUploadItem